import React from "react";

export default function Business() {
  return (
    <div className="page">
      <h1>Business Solutions</h1>
      <p>Overview of business solutions.</p>
    </div>
  );
}
